import { GasDetectorResponse, HookResponse } from 'modules/maps';
import { useEffect } from 'react';
import {
  createMarkerContainer,
  createMarkerImg,
  createLinkBadge,
  createTooltip,
  showTooltip,
  hideTooltip
} from '../utils.ts';
import { ptwMapImages } from '../../../../../../../constants';

type GasDetectorMarkerProps = {
  map: google.maps.Map | null;
  isLoaded: boolean;
  gasDetectorList: GasDetectorResponse[];
  onSelectGas?: (hook: GasDetectorResponse | null) => void;
};

export function GasDetectorMarker({
  map,
  isLoaded,
  gasDetectorList,
  onSelectGas
}: GasDetectorMarkerProps) {
  useEffect(() => {
    if (!isLoaded || !map) return;
    if (!google.maps.marker?.AdvancedMarkerElement) return;

    const mapDiv = map.getDiv();
    const tooltip = createTooltip();
    mapDiv.appendChild(tooltip);

    const markers: google.maps.marker.AdvancedMarkerElement[] = [];

    gasDetectorList
      .filter((c) => Number.isFinite(c.lat) && Number.isFinite(c.lng))
      .forEach((c) => {
        const container = createMarkerContainer(40);
        container.appendChild(createMarkerImg(ptwMapImages.iot, c.deviceName, 40));
        const linkBadge = createLinkBadge(c.ptwNo, ptwMapImages.link);
        if (linkBadge) container.appendChild(linkBadge);

        const tooltipRows = [
          { label: 'Device Name', value: c.deviceName },
          { label: 'Status', value: c.status },
          ...(c.ptwNo ? [{ label: 'PTW', value: c.ptwNo }] : [])
        ];

        container.addEventListener('mouseenter', (e: MouseEvent) => {
          const rect = mapDiv.getBoundingClientRect();
          showTooltip(tooltip, tooltipRows, e.clientX - rect.left, e.clientY - rect.top);
        });
        container.addEventListener('mousemove', (e: MouseEvent) => {
          const rect = mapDiv.getBoundingClientRect();
          showTooltip(tooltip, tooltipRows, e.clientX - rect.left, e.clientY - rect.top);
        });
        container.addEventListener('mouseleave', () => hideTooltip(tooltip));

        const marker = new google.maps.marker.AdvancedMarkerElement({
          map,
          position: { lat: c.lat, lng: c.lng },
          title: c.deviceName,
          content: container,
          gmpClickable: true
        });
        const handler = () => {
          console.log(c);
          onSelectGas?.(c);
        };
        marker.addEventListener('gmp-click', handler);
        markers.push(marker);
      });

    return () => {
      markers.forEach((m) => (m.map = null));
      tooltip.remove();
    };
  }, [map, isLoaded, gasDetectorList]);

  return null;
}
